import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { TcAccordionComponent } from './tc-accordion.component';

@NgModule({
  declarations: [TcAccordionComponent],
  imports: [
    CommonModule,
    MatExpansionModule,
    MatButtonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ShimanoAccordionComponent: {
          component: TcAccordionComponent,
        },
      },
    } as CmsConfig),
  ],
  exports: [TcAccordionComponent],
  providers: [{ provide: TcAccordionComponent }],
})
export class TcAccordionModule {}
